module.exports = __webpack_public_path__ + "4606892c6154c236c8ba274ac23ab5c8.png";


//////////////////
// WEBPACK FOOTER
// ./components/bare_home/sothebys.png
// module id = 597
// module chunks = 0